import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: e = 16, useVw: t, useRem: o, color: n, withColor: c, removeClassName: l, disableSSR: m, style: i, ...p }) => {
  const f = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-dazongjiaoyifuwu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-å¤§å®äº¤ææå¡"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: c ? r(n, 0, "#262933") : "#262933",
        datafollowfill: c ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.5 4.6a4.9 4.9 0 1 0 0 9.8 4.9 4.9 0 0 0 0-9.8Zm-3.1 4.9a3.1 3.1 0 1 1 6.2 0 3.1 3.1 0 0 1-6.2 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M5 11.1a.9.9 0 0 1 .9.9v1.585h4.957c1.25 0 2.395.707 2.954 1.826l.345.69h2.4c1.213 0 2.336.638 2.955 1.68l1.811 3.051 3.88-.435a2.833 2.833 0 0 1 1.112 5.535l-4.336 1.27a15.9 15.9 0 0 1-9.218-.083l-4.029-1.26a.9.9 0 0 1 .538-1.718l4.029 1.26a14.1 14.1 0 0 0 8.174.074l4.336-1.27a1.033 1.033 0 0 0-.406-2.019l-4.457.5a.897.897 0 0 1-.149.004l-5.345-.291a.9.9 0 0 1 .098-1.797l3.661.199-1.247-2.1c-.294-.497-.83-.8-1.406-.8h-2.958a.9.9 0 0 1-.805-.498l-.593-1.187a1.503 1.503 0 0 0-1.344-.83H5.906L5.9 27a.9.9 0 1 1-1.8 0V12a.9.9 0 0 1 .9-.9Z"
        }
      )
    )
  )));
}, s = g;
export {
  s as default
};
